import React, {useEffect, useState} from 'react'
import {Box, Typography, Grid, Modal, Divider} from '@material-ui/core'
import {withStyles} from '@material-ui/core/styles'
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import Helmet from 'react-helmet'
import {BUSINESS_NAME} from 'config'

const styles = theme => ({
  productBox: {
    userSelect: 'none',
    padding: theme.spacing(2),
    backgroundColor: '#fffaf5',
    borderRadius: '5px',
    minHeight: '40px',
    marginBottom: theme.spacing(1),
    boxShadow: '1px 2px 4px 0px #decab5',
    width: '90%'
  },
  productsContainer: {
    marginBottom: theme.spacing(12),
    width: '100%'
  },
  productCategory: {
    userSelect: 'none'
  },
  productPrice: {
    userSelect: 'none',
    fontSize: '26px',
    color: 'white',
    fontWeight: 300,
    backgroundColor: theme.palette.secondary.main,
    float: 'right',
    padding: '5px 15px',
    borderRadius: '50px',
    boxShadow: 'inset -2px -3px 3px 0px #a59079',
    border: '1px solid #fff'
  },
  paper: {
    position: 'absolute',
    width: '98%',
  },
  photoIcon: {
    width: '40px',
    height: '40px',
    boxShadow: '0px 1px 3px 1px #46413b8f',
    borderRadius: '8px',
    border: '1px solid white'
  }
})


function getModalStyle() {
  const top = 25;
  return {
    top: `${top}%`,
    margin: 'auto'
  };
}

const PhotoPreview = ({photos, thumbs, classes}) => {
  const [open, setOpen] = useState(false)
  const [photoIndex,setPhotoIndex] = useState(0)
  return <>
    {photos && photos.length > 0 && photos.map((photo,index)=>{
      return <img key = {`photo${index}`} src={thumbs[index]} className={classes.photoIcon} onClick={() => {
        setOpen(true)
        setPhotoIndex(index)
      }}/>
      })
  }
  {open && (
        <Lightbox
          mainSrc={photos[photoIndex]}
          nextSrc={photos[(photoIndex + 1) % photos.length]}
          prevSrc={photos[(photoIndex + photos.length - 1) % photos.length]}
          onCloseRequest={() => setOpen(!open)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % photos.length)
          }
        />
      )}
    </>
    }

    const ProductsView = withStyles(styles)(({products, category, classes, ...props}) => {

    const [productsFilters, setProductsFiltered] = useState([])
    useEffect(() => {
    const productsByCategory = products.filter(function (obj) {
    return obj.categoryId === category.id
  })
    if (productsByCategory) {
    setProductsFiltered(productsByCategory)
  }
    window.scrollTo(0, 0)

  }, [category, products])

    return <>
    <Helmet>
    <title> {`${BUSINESS_NAME} | ${category.name ? category.name : ''} `}</title>
    </Helmet>
    <Box className={classes.productsContainer}>
    {productsFilters.map((product) => {
      return <Box key={product.productId} className={classes.productBox}>
        <Grid container direction={'row'} alignItems={'flex-start'} justify={'flex-start'}>
          <Grid item xs={8}>
            <Box mr={1}>
              <Typography variant={'h5'} color={'primary'}>{product.name}</Typography>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box className={classes.productPrice}>
              <Typography variant={'h5'}>{product.price}€</Typography>
            </Box>
          </Grid>

          <Grid item xs={7}>
            <Box>
              <Typography variant={'subtitle2'} color={'secondary'}>{product.description}</Typography>
            </Box>
          </Grid>
          {product.photo_thumb &&
          <Grid container justify='flex-start' alignItems='flex-start' alignContent='flex-start' direction='row'>
            <Grid item xs={12}>
              <Divider/>
            </Grid>
                <Grid item xs={4}>
                  <Box mr={1} mt={1} mb={-1}>
                    <PhotoPreview photos={product.photo_full} thumbs={product.photo_thumb}
                                  classes={classes}/>
                  </Box>
                </Grid>
          </Grid>}
        </Grid>
      </Box>
    })}
    </Box>
    </>
  })


    export default ProductsView